import { render } from "./UuidGenerator.vue?vue&type=template&id=f3628d78&scoped=true"
import script from "./UuidGenerator.vue?vue&type=script&lang=js"
export * from "./UuidGenerator.vue?vue&type=script&lang=js"

import "./UuidGenerator.vue?vue&type=style&index=0&id=f3628d78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3628d78"]])

export default __exports__